export const copyToClipboard = (text: string) => window.navigator.clipboard.writeText(text);
